/**
 * Format a date as a relative time string (e.g., "yesterday", "last week", "last month")
 */
export const formatRelativeDate = (date) => {
  if (!date) return 'Never';

  const now = new Date();
  const then = new Date(date);
  const diffMs = now - then;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  // Less than a minute ago
  if (diffSecs < 60) {
    return 'Just now';
  }

  // Less than an hour ago
  if (diffMins < 60) {
    return diffMins === 1 ? '1 minute ago' : `${diffMins} minutes ago`;
  }

  // Less than a day ago
  if (diffHours < 24) {
    return diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`;
  }

  // Today (same calendar day)
  if (diffDays === 0) {
    return 'Today';
  }

  // Yesterday
  if (diffDays === 1) {
    return 'Yesterday';
  }

  // Less than a week ago
  if (diffDays < 7) {
    return `${diffDays} days ago`;
  }

  // Less than a month ago
  if (diffWeeks < 4) {
    if (diffWeeks === 1) {
      return 'Last week';
    }
    return `${diffWeeks} weeks ago`;
  }

  // Less than a year ago
  if (diffMonths < 12) {
    if (diffMonths === 1) {
      return 'Last month';
    }
    return `${diffMonths} months ago`;
  }

  // More than a year ago
  if (diffYears === 1) {
    return 'Last year';
  }
  return `${diffYears} years ago`;
};

